module.exports = __webpack_public_path__ + "img/drug-36.1ea715a3.png";